module.exports = __webpack_public_path__ + "img/icon-revert.7fe6d5e2.svg";